import { render, staticRenderFns } from "./DatasetCollectionDialog.vue?vue&type=template&id=03b154c8&"
import script from "./DatasetCollectionDialog.vue?vue&type=script&lang=js&"
export * from "./DatasetCollectionDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports